import * as theme from "../theme";

import { useContext, useEffect } from "react";

import styled from "styled-components";
import GuildLogoSrc from "../assets/images/guild_logo.png";
import Spinner from "../components/Spinner";
import Context from "../contexts/data";

const Result = () => {
  const {
    isFetchResult,
    showGuildOnTYP,
    firstName,
    lastName,
    phoneNumber,
    email,
    address,
    city,
    state,
    zipCode,
    ppcid,
    cid
  } = useContext(Context);

  const fullName =
    firstName && lastName ? `${firstName} ${lastName}` : "RateZip User";

  // Set BrightOffers pre-population variables
  useEffect(() => {
    window.bhm_firstname = firstName || "";
    window.bhm_lastname = lastName || "";
    window.bhm_phone = phoneNumber || "";
    window.bhm_email = email || "";
    window.bhm_dob = ""; // Not available in context
    window.bhm_address = address || "";
    window.bhm_city = city || "";
    window.bhm_state = state || "";
    window.bhm_zip = zipCode || "";
    window.bhm_monthly_income = ""; // Not available in context
    window.bhm_sub1 = ppcid || "";
    window.bhm_sub2 = cid || "";
  }, [firstName, lastName, phoneNumber, email, address, city, state, zipCode, ppcid, cid]);

  let lenderMatchContent = (
    <SmallerTextContainer>
      <SmallerText>
        You've been matched to our premier lender.
      </SmallerText>
    </SmallerTextContainer>
  );

  if (showGuildOnTYP) {
    lenderMatchContent = (
      <>
        <SmallerTextContainer>
          <SmallerText>
            Below are the lender(s) you were matched to. We are sharing their
            contact information with you so you know who will be contacting you
            about your loan inquiry.
          </SmallerText>
        </SmallerTextContainer>
        <LogoContainer>
          <GuildLogo src={GuildLogoSrc} alt="Guild Mortgage Logo" />
          <p>NMLS ID 3274</p>
        </LogoContainer>
      </>
    );
  }

  if (isFetchResult) {
    return (
      <Wrapper>
        <HeadBiggerTextContainer>
          <HeadBiggerText>Thank you {fullName}.</HeadBiggerText>
        </HeadBiggerTextContainer>
        <Spinner text="Loading your offers..." />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <HeadWrapper>
        <HeadBiggerTextContainer>
          <HeadBiggerText>
            Thank you for submitting your request.
          </HeadBiggerText>
        </HeadBiggerTextContainer>
        <HeadSmallerTextContainer>
          <HeadSmallerText>
            {`Congratulations ${fullName}, You have completed the first step in
              starting your loan process.`}
          </HeadSmallerText>
        </HeadSmallerTextContainer>
        <BlueLine />
      </HeadWrapper>
      <TextsContainer>
        <BiggerTextContainer>
          <BiggerText>Reverse mortgage request</BiggerText>
        </BiggerTextContainer>
        {lenderMatchContent}
      </TextsContainer>
      <OfferContainer>
        <div class="bhm-offer" data-id="65853ddd5ab5-6a0c-9f60-49fe-4e1a-b78cdcd0" data-afid="692"></div>
      </OfferContainer>
      <BottomTextContainer>
        <BottomText>
          YOUR OFFER: RateZip receives compensation for all licensed mortgage
          lenders which appear above. The compensation can impact the order and
          the prominence of the offers. All available lenders and options
          available are not always included. All offers are based on the
          information you provided to RateZip and are conditional preliminary
          offers that are subject to change based on completion of a mortgage
          application with the lender and verification of all information
          provided and any other conditions as required by the lender.
        </BottomText>
      </BottomTextContainer>
    </Wrapper>
  );
};

const OfferContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin-top: 2rem;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin: 3rem 0;
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    color: #666666;
    font-size: 1rem;
    margin: 0;

    @media (max-width: 900px) {
      font-size: 0.75rem;
    }
  }
`;

const GuildLogo = styled.img`
  width: ;
`;

const Wrapper = styled(theme.column_align)`
  width: 95%;
  margin-top: 2rem;
`;

const HeadWrapper = styled.div`
  width: 100%;
`;

const HeadBiggerTextContainer = styled.div``;

const HeadBiggerText = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 64px;
  margin-bottom: 16px;
  margin-top: 0px;
  @media (max-width: ${theme.mobile}) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const HeadSmallerTextContainer = styled.div``;

const HeadSmallerText = styled.h3`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  margin: 0px 0px 32px 0px;
  @media (max-width: ${theme.mobile}) {
    font-size: 18px;
    line-height: 18px;
  }
`;

const BlueLine = styled.div`
  width: 86px;
  height: 4px;
  background: ${theme.primary_light};
`;

const TextsContainer = styled.div`
  width: 100%;
`;

const BiggerTextContainer = styled.div``;

const BiggerText = styled.h2`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  margin: 32px 0px 0px 0px;
  @media (max-width: ${theme.mobile}) {
    font-size: 18px;
    line-height: 32px;
  }
`;

const SmallerTextContainer = styled.div``;

const SmallerText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  margin: 0px 0px 16px 0px;
  @media (max-width: ${theme.mobile}) {
    font-size: 14px;
  }
`;

const BottomTextContainer = styled.div``;

const BottomText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #666666;
`;

export default Result;
